module.exports = __webpack_public_path__ + "static/media/riskStep5.319ec054.svg";